export default __webpack_public_path__ + "static/media/mprojectfeature4.6238879f.png";